import React, { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Cursor() {
  const [enabled, setEnabled] = useState(false);
  const [hovering, setHovering] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const ringX = useSpring(x, { stiffness: 250, damping: 24 });
  const ringY = useSpring(y, { stiffness: 250, damping: 24 });

  useEffect(() => {
    if (window.matchMedia("(pointer: fine)").matches) {
      setEnabled(true);
      document.body.classList.add("cursor-none-desktop");
    }
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      setHovering(!!e.target.closest("a, button, [data-cursor], input, select, textarea, [role='button']"));
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      document.body.classList.remove("cursor-none-desktop");
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        className="pointer-events-none fixed left-0 top-0 z-[190] h-2 w-2 rounded-full"
        style={{ x, y, translateX: "-50%", translateY: "-50%", background: "var(--mn-gold-glow)" }}
      />
      <motion.div
        className="pointer-events-none fixed left-0 top-0 z-[190] rounded-full border"
        style={{ x: ringX, y: ringY, translateX: "-50%", translateY: "-50%", borderColor: "var(--mn-gold)" }}
        animate={{
          width: hovering ? 48 : 30,
          height: hovering ? 48 : 30,
          opacity: hovering ? 1 : 0.6,
          backgroundColor: hovering ? "rgba(212,175,55,0.08)" : "rgba(212,175,55,0)",
        }}
        transition={{ duration: 0.2 }}
      />
    </>
  );
}
